import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';

function Button(props) {
  const {
    style,
    className,
    type,
    onClick,
    disabled,
    text,
    icon,
    cancel,
  } = props;

  return (
    <button
      style={style}
      className={`${styles.button} ${className} ${cancel ? styles.cancel : ''}`}
      // eslint-disable-next-line react/button-has-type
      type={type || 'button'}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
      {icon ? (
        <div className={styles.icon}>
          {icon}
        </div>
      ) : null}
    </button>
  );
}

Button.defaultProps = {
  style: null,
  className: '',
  type: '',
  onClick: null,
  disabled: false,
  text: '',
  icon: null,
  cancel: false,
};

Button.propTypes = {
  className: PropTypes.string,
  style: PropTypes.instanceOf(Object),
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  icon: PropTypes.element,
  cancel: PropTypes.bool,
};

export default Button;